/* Router dependencies */
import Vue from 'vue';
import VueRouter from 'vue-router';
import RecipesListPage from '@/components/recipes-app-hook/recipes-list-page.vue';
import { getMountPointId } from '@/helpers/utils.js';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'index',
    component: RecipesListPage,
    props: true,
  },
  {
    path: '*',
    redirect: { name: 'index' },
  },
];

const router = new VueRouter({
  base: window.location.pathname,
  mode: 'history',
  routes,
});

export default router;
